export default "__VITE_ASSET__SOAZ0aKz__"